import styled from '@emotion/styled';
import Icon from '@icon/Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const CalenderClock = (props) => {
  const { color, fill, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 16 16" {...rest}>
      <circle
        cx={12}
        cy={12.25}
        r={2.75}
        stroke="#7A8B94"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.934 11.323v1.072l.844.515"
        stroke="#7A8B94"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.001 2.334v1.5M5 2.334v1.5M1.998 6.836h12.005M14 7.744V5.418c0-1.334-1.007-2.415-2.25-2.415h-7.5C3.007 3.003 2 4.084 2 5.418v6.17c0 1.334 1.007 2.415 2.25 2.415h3.083"
        stroke="#7A8B94"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

export default CalenderClock;
